import React, { useState, useEffect } from "react";
import ProSaleCounter from "./ProSaleCounter";
import { ethers } from "ethers";
import { useAccount, useConnect, useDisconnect, useNetwork, useSigner } from 'wagmi';
import { switchNetwork } from '@wagmi/core';

const ProSaleBanner = () => {
  const { address, isConnected } = useAccount();
         const { chain } = useNetwork();
         const { data: signer, isError, isLoading } = useSigner();
 const exceptTheseSymbols = ["e", "E", "+", "-", "."];
  const tokenAddress = "0xF4Bc75F3C2B5203B408d86b992B6D6E8C0b3B240";
const tokenABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "reason",
        "type": "string"
      }
    ],
    "name": "Unauthorized",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "Approval",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "approve",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "subtractedValue",
        "type": "uint256"
      }
    ],
    "name": "decreaseAllowance",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "addedValue",
        "type": "uint256"
      }
    ],
    "name": "increaseAllowance",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "mint",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "pause",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "Paused",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "transfer",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "Transfer",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "transferFrom",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "unpause",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "Unpaused",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "value",
        "type": "bool"
      }
    ],
    "name": "updateMintLive",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "withdraw",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      }
    ],
    "name": "allowance",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "cap",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "circulatingSupply",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "decimals",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getCirculatingSupply",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getLatestPrice",
    "outputs": [
      {
        "internalType": "int256",
        "name": "",
        "type": "int256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maxSupply",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "mintAmount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "mintLive",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "paused",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalSupply",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "userAddress",
        "type": "address"
      }
    ],
    "name": "userBalance",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];


useEffect(() => {

     async function onInit() {

      if(isConnected){
      let account = address;
  const baseProvider = new ethers.providers.JsonRpcProvider(`https://goerli.base.org`);
  const tokenContract = new ethers.Contract(tokenAddress, tokenABI, baseProvider);
  let mintButton = document.getElementById('mintButton');
        mintButton.style.opacity = "initial";
          mintButton.style.cursor = "pointer";
          mintButton.disabled = false;
  let ethCalc = await tokenContract.getLatestPrice();
  let mintedAmount = await tokenContract.getCirculatingSupply();
  let totalMinted = document.getElementById('totalMinted');
  let percentMinted = document.getElementById('percentMinted');
  let purchaseLimit = document.getElementById('purchaseLimit');
   totalMinted.innerHTML = "$"+String(mintedAmount*0.03).substr(0,8);
  percentMinted.style.width = ((mintedAmount/1000000)*100)+"%";
  let balance = await tokenContract.userBalance(account);
  let userLimit = 50000 - balance;
  purchaseLimit.innerHTML = "Cannot Exceed Remaining Wallet Limit of "+userLimit;
  if(chain.id == 84531){
    let mintButton = document.getElementById('mintButton');
    mintButton.innerHTML = "Mint";
  }else{
let mintButton = document.getElementById('mintButton');
    mintButton.innerHTML = "Switch To Base Network";
  }
  }else{
    const baseProvider = new ethers.providers.JsonRpcProvider(`https://goerli.base.org`);
     const tokenContract = new ethers.Contract(tokenAddress, tokenABI, baseProvider);
     let mintButton = document.getElementById('mintButton');
       mintButton.style.opacity = "0.25";
          mintButton.style.cursor = "not-allowed";
          mintButton.disabled = true;
    let ethCalc = await tokenContract.getLatestPrice();
  let mintedAmount = await tokenContract.getCirculatingSupply();
  let totalMinted = document.getElementById('totalMinted');
  let percentMinted = document.getElementById('percentMinted');
  let purchaseLimit = document.getElementById('purchaseLimit');
   totalMinted.innerHTML = "$"+String(mintedAmount*0.03).substr(0,8);
  percentMinted.style.width = ((mintedAmount/1000000)*100)+"%";
  }
}

  onInit();
  });

const tokenMint = async event => {
  if(isConnected){
  const baseProvider = new ethers.providers.JsonRpcProvider(`https://goerli.base.org`);
    let baseNetwork = 84531;
    const tokencontract2 = new ethers.Contract(tokenAddress, tokenABI, baseProvider);
    const tokenmint = new ethers.Contract(tokenAddress, tokenABI, signer);
    let account = address;
    let ethCalc = await tokencontract2.getLatestPrice();
    let mintCalc = 0.03 / ethCalc;
   let quantity = document.getElementsByName("quantity")[0].value;
     let mintButton = document.getElementById('mintButton');
   let totalPrice = (mintCalc*Math.pow(10,18));
   if(chain.id == baseNetwork){
  await tokenmint.mint(parseInt(quantity), { from: account, value: ""+String(Math.ceil(totalPrice*quantity))+"", maxPriorityFeePerGas: null,
    maxFeePerGas: null,});}else{ 
      try {
          await switchNetwork({
            chainId: 84531,
          });
        }catch(error){
          console.log(error);
        }
    }
      }
    }

      const handleChange = async event => {
        if(isConnected){
        const baseProvider = new ethers.providers.JsonRpcProvider(`https://goerli.base.org`);
    const tokencontract3 = new ethers.Contract(tokenAddress, tokenABI, baseProvider);
    let account = address;
    let supply = await tokencontract3.getCirculatingSupply();
    let balance = await tokencontract3.userBalance(account);
    let userLimit = 50000 - balance;
    let quantityRemaining = 1000000 - supply;
    if(quantityRemaining > userLimit){
      quantityRemaining = userLimit;
    let cost = document.getElementById('tokenCost');
    let quantity = document.getElementsByName("quantity")[0];
    if(quantity.value > quantityRemaining){
    quantity.value = quantityRemaining
    cost.innerHTML = "$"+String(quantityRemaining * 0.03).substr(0,4);
  }else{
    cost.innerHTML = "$"+String(document.getElementsByName("quantity")[0].value * 0.03).substr(0,4);
  }
  }}else{
    
  }
  };
    

  return (
    <div className="container -translate-y-24">
      <div className="rounded-2.5xl bg-light-base px-6 py-6 shadow-sm dark:bg-jacarta-700 md:px-8 lg:px-12">
        <div className="lg:flex">
             <div className="lg:w-[40%] lg:text-left text-center">
             <h2 className="font-display text-3xl text-jacarta-700 dark:text-white">
              VS Token is <span className="text-accent">Live!</span>
            </h2>
            
            <p className="mb-8 text-jacarta-500 dark:text-jacarta-300">
              Price: 3c / ea
              <br />
              Max Mint Per Wallet: 50K Tokens
              <br />
              Total Supply: 1 Million
            </p>
            </div>
            <div style={{margin: '0 auto'}} className="mt-4 sm:mt-0 lg:w-[60%] sm:w-1/2 lg:pr-6 pb-2">
                          <span className="js-countdown-ends-label text-jacarta-400 dark:text-jacarta-300 text-sm">
                            Quantity
                          </span><br />
                          <div className="mt-2 dark:border-jacarta-600 border-jacarta-100 relative mb-2 flex items-center overflow-hidden rounded-lg border">
                <div className="border-jacarta-100 bg-jacarta-50 flex flex-1 items-center self-stretch border-r px-2">
                 
                  <span className="font-display w-full text-jacarta-700 text-sm">
                    Amount
                  </span>

                </div>

                <input id="quantityInput"
                   type="number"
                   min="1"
                  onChange={handleChange}
                  name="quantity"
                  onKeyDown={ (e) => exceptTheseSymbols.includes(e.key) && e.preventDefault()}
                  onPaste={ (e)=> e.preventDefault() }
                  onDrop={ (e)=> e.preventDefault() }
                  className="focus:ring-accent h-12 w-full flex-[3] border-0 focus:ring-inse dark:text-jacarta-700"
                
                />

                <div className="bg-jacarta-50 border-jacarta-100 flex flex-1 justify-end self-stretch border-l dark:text-jacarta-700">
                  <span className="self-center w-full px-2 text-sm" id="tokenCost">$0.00</span>
                </div>
              </div>
              <span id="purchaseLimit" className="js-countdown-ends-label text-jacarta-400 dark:text-jacarta-300 text-sm">
                            
                          </span>
                        </div>
             <div className="flex-wrap lg:w-[60%]">
             <button id="mintButton"
              onClick={() => tokenMint()}
              className="inline-block w-full rounded-full bg-accent py-2.5 px-8 text-center text-sm font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
            >
              Mint
            </button>
              <div className="mb-2 mt-2 flex dark:text-jacarta-300">
              <span className="text-left">
                Reached: <span id="totalMinted" className="text-green"></span>
              </span>
              <span className="ml-auto text-right">$30K</span>
            </div>
            <div className="rounded ml-auto bg-accent-lighter">
              <div id="percentMinted" className="h-4 rounded bg-accent" />
            </div>
            <div className="mt-2 mb-2 flex justify-between dark:text-jacarta-300">
              <span>Softcap</span>
              <span>Hardcap</span>
            </div>
            
            
            </div>
            </div>
             
             
             
            {/* End pro sale countdown banner */}
         
        
          </div>
      </div>
  );
};

export default ProSaleBanner;
